import { Skeleton, Table } from 'antd';

import { PREFIX } from '@app/constants';
import { ConfirmSalaryModal } from '@app/pages/Analytics/components';
import {
  useSalaryInfo,
  useSalaryInfoEffects,
} from '@app/pages/Users/UserProfile/components/SalaryInfo/hooks';
import { getColumns } from '@app/pages/Users/UserProfile/components/SalaryInfo/utils';

export const SalaryInfo: React.FC = () => {
  const { data, isLoading, confirmed, setConfirmed } = useSalaryInfoEffects();
  const {
    initialData,
    openConfirmModal,
    isConfirmModalOpen,
    setIsConfirmModalOpen,
    selectedRowIndex,
    setSelectedRowIndex,
  } = useSalaryInfo({ data });

  if (isLoading) {
    return <Skeleton active />;
  }

  return (
    <div className={`${PREFIX}salary-info`}>
      <Table
        dataSource={initialData}
        columns={getColumns({ confirmed, openConfirmModal })}
        pagination={false}
        rowKey="key"
        bordered={false}
        showHeader={false}
      />
      <ConfirmSalaryModal
        isOpen={isConfirmModalOpen}
        selectedRowIndex={selectedRowIndex}
        setSelectedRowIndex={setSelectedRowIndex}
        setConfirmed={setConfirmed}
        setIsOpen={setIsConfirmModalOpen}
        year={data?.Salaries?.[selectedRowIndex ?? -1]?.Year || ''}
        month={data?.Salaries?.[selectedRowIndex ?? -1]?.Month || ''}
        userId={data?.UserId}
        showComment={false}
      />
    </div>
  );
};
